import React from 'react';

function PayForServicesContent() {
  return (
    <>
      <p>Information about service requirements and API integrations for Repo Prompt.</p>
      <h3>Service Requirements</h3>
      <p>Yes and no. Repo Prompt supports advanced clipboard features to help you bring your prompts to any AI chat interface. There is no provided inference out of the box, but you can connect a GitHub account or Gemini API key to access free models. There are also a number of free models available via Open Router.</p>
    </>
  );
}

export default PayForServicesContent;